import { Box, IconButton, SxProps, Theme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDrawer } from 'services/drawer/hooks';

const container = {
  position: 'absolute',
  top: 24,
  right: 32,
  zIndex: 4,
  color: 'primary.main'
} satisfies SxProps<Theme>;

type Props = {
  containerSx?: SxProps<Theme>;
  buttonSx?: SxProps;
};

export const DrawerCloseButton: React.FC<Props> = ({
  containerSx,
  buttonSx
}) => {
  const { closeDrawer } = useDrawer();

  return (
    <Box
      sx={[
        container,
        ...(Array.isArray(containerSx) ? containerSx : [containerSx])
      ]}
    >
      <IconButton onClick={closeDrawer} sx={buttonSx}>
        <CloseIcon
          sx={{
            color: 'error.main'
          }}
        />
      </IconButton>
    </Box>
  );
};
